import { useLocation } from 'react-router-dom';

/**
 * Subscribe to hash modifications.
 *
 * @returns The hash without the leading #.
 */
export const useHash = () => useLocation().hash.replace(/^#/, '');
